import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card } from 'react-bootstrap';

import { ClaimControlForm } from './claim-control-form';
import { ClaimListView } from './claim-list-view';

const InsuranceClaimListPage = () => {
  const { t } = useTranslation();

  return (
    <section>
      <h5 className="mb-4">{t('common:claim')}</h5>
      <ClaimControlForm />
      <Card>
        <Card.Body>
          <ClaimListView />
        </Card.Body>
      </Card>
    </section>
  );
};

export { InsuranceClaimListPage };
